
/**
 * Functions for generating conclusion content
 */

export function generateConclusion(babyName: string, age: string): string {
  const conclusions = [
    `As I watch ${babyName} grow at ${age}, I'm reminded of how quickly time passes and how precious each day truly is.`,
    `Every day with ${babyName} at ${age} brings new discoveries and deeper love. I'm treasuring each moment of this journey.`,
    `It's remarkable how much ${babyName} has already changed and developed at just ${age}. I can't wait to see what tomorrow brings.`,
    `These days with ${babyName} at ${age} may be filled with small moments, but they're weaving together the beautiful story of their childhood.`,
    `As ${babyName} continues to grow at ${age}, I'm trying to memorize every detail - the tiny fingers, the sweet expressions, the unique personality emerging day by day.`,
    `${babyName} at ${age} is such a wonder - I find myself pausing throughout the day just to take in all the ways they're changing and developing.`,
    `The privilege of watching ${babyName} explore the world at ${age} fills me with gratitude for each ordinary, extraordinary day.`,
    `I look at ${babyName} at ${age} and marvel at how someone so small can bring such immense joy and meaning to our lives.`,
    `${babyName}'s journey at ${age} is unfolding in beautiful ways, each day revealing new facets of who they are becoming.`,
    `Witnessing ${babyName}'s growth at ${age} is a daily reminder of life's most precious gift - the ability to love and be loved so completely.`,
    `At ${age}, ${babyName} teaches me daily about patience, wonder, and finding joy in the smallest moments.`,
    `${babyName} at ${age} is changing so rapidly - I'm grateful for these diary entries to capture the fleeting stages of babyhood.`
  ];
  
  return conclusions[Math.floor(Math.random() * conclusions.length)];
}
